import React from 'react';
import _ from 'lodash';
import { useTheme } from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import { filterInstallationsVar } from 'modules/common/layer00/reactiveVariables';
import { CustomIcon } from 'modules/components/layer00';
import { StyledTextField } from 'modules/components/layer01';



export type InstallationSearchBarProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationSearchBarProps) => {
  const theme = useTheme();

  const installationFilter = useReactiveVar(filterInstallationsVar);
  return (

    <StyledTextField.FC
      placeholder='Search'
      value={_.isNull(installationFilter.freeTextSearch) ? '' : installationFilter.freeTextSearch}
      startAdornment={(
        <CustomIcon.large.FC
          icon='SEARCH'
          stroke={theme.palette.primary.main}
        />
      )}
      onChange={(e) => {
        filterInstallationsVar({
          ...installationFilter,
          freeTextSearch: e.target.value === '' ? null : e.target.value
        });
      }}
    />

  );
};
